// Каталог страниц, видимость которых настраивается у кастомных ролей.
// key должен совпадать с ключами на бэкенде (main.py PAGE_CATALOG),
// label — со строкой activePage и пунктом меню в Sidebar.
export const PAGES = [
  { key: "payments", label: "Реестр платежей" },
  { key: "counterparties", label: "Контрагенты" },
  { key: "reports", label: "Отчеты" },
  { key: "directory", label: "Справочник" },
  { key: "template", label: "Шаблон" },
  { key: "personal_menus", label: "Персональные меню" },
  { key: "settings", label: "Настройки" },
  { key: "users", label: "Пользователи" }
];

export const PAGE_LABELS = PAGES.reduce((acc, page) => {
  acc[page.key] = page.label;
  return acc;
}, {});
